import React from 'react';
import Icon from './Icon';
import { BENEFITS } from '../data/content';

export default function Benefits() {
  return (
    <section id="benefits" className="section section-alt">
      <div className="container">
        <div className="section-header reveal">
          <span className="eyebrow">Business Impact</span>
          <h2 className="section-title">Measurable Benefits, Not Just Technology</h2>
          <p className="section-subtitle">
            Every engagement is designed around outcomes your leadership team actually cares about.
          </p>
        </div>

        <div className="benefits-grid">
          {BENEFITS.map((b, i) => (
            <div className="benefit-card reveal" key={b.title} style={{ transitionDelay: `${i * 0.08}s` }}>
              <span className="benefit-badge">{b.tag}</span>
              <div className="benefit-icon">
                <Icon name={b.icon} size={24} />
              </div>
              <h3>{b.title}</h3>
              <p>{b.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}